import { render, staticRenderFns } from "./SectionNonMarie.vue?vue&type=template&id=51afb9ae&scoped=true&"
import script from "./SectionNonMarie.vue?vue&type=script&lang=js&"
export * from "./SectionNonMarie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afb9ae",
  null
  
)

export default component.exports